import React from "react";
import { Fragment } from "react";
import { Tab } from "@headlessui/react";
import AddProduct from "../AddProduct";
import AddCategory from "../AddCategory";

const TabsContainer = () => {
  const selectedTabClass =
    "rounded bg-primary p-2 md:p-3 text-white font-nunito text-sm";
  const unSelectedTabClass =
    "rounded bg-smoot p-2 md:p-3 text-secondary/50 font-nunito text-sm";
  return (
    <div className="mt-10 w-full md:mt-0 md:w-6/12">
      <Tab.Group>
        <Tab.List className="flex space-x-2 md:space-x-4">
          <Tab as={Fragment}>
            {({ selected }) => (
              <button
                className={selected ? selectedTabClass : unSelectedTabClass}
              >
                <span className="hidden sm:inline">Ajouter un</span> article
              </button>
            )}
          </Tab>

          <Tab as={Fragment}>
            {({ selected }) => (
              <button
                className={selected ? selectedTabClass : unSelectedTabClass}
              >
                <span className="hidden sm:inline">Ajouter une</span> catégorie
              </button>
            )}
          </Tab>
        </Tab.List>
        <Tab.Panels>
          <Tab.Panel>
            <AddProduct />
          </Tab.Panel>
          <Tab.Panel>
            <AddCategory />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default TabsContainer;
